export type VoteLevel = 'cold' | 'warm' | 'hot';

// <= 0 : froid (bleu), 1..10 : chaud (orange), > 10 : brûlant (rouge)
export function getVoteLevel(score: number | null | undefined): VoteLevel {
  const value = score ?? 0;
  if (value <= 0) {
    return 'cold';
  }
  return value > 10 ? 'hot' : 'warm';
}
